import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getThemes } from './themes';

class ThemeSwitcher extends Component {

  constructor(props) {
    super(props);
    const allThemes = getThemes();

    this.state = {
      theme: allThemes[11]
    }

  }

  getChildContext() {
    return {
      theme: this.state.theme,
      switchTheme: this.switchTheme
    };
  }

  componentDidMount() {
    this._syncThemeColor();
  }

  _syncThemeColor() {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', '#050208');
  }

  switchTheme = (theme) => {
    this.setState({ theme });
  }

  render() {
    const { children } = this.props;
    const theme = this.state.theme;

    return (
      <div className="theme-switcher">
        <style jsx="true">
        {`
          body, h1, h2, h3, h4, h5, h6, p, ol, ul {
            color: ${theme.textPrimary};
          }
        `}
        </style>
        { children }
      </div>
    );
  }
}

ThemeSwitcher.propTypes = {
  children: PropTypes.node
}

ThemeSwitcher.childContextTypes = {
  theme: PropTypes.any,
  switchTheme: PropTypes.func
}

export default ThemeSwitcher;


// WEBPACK FOOTER //
// ./src/components/ThemeSwitcher/ThemeSwitcher.js